import React from 'react';

const LegalSectionCard = ({ id, title, children }) => (
  <article className="legal-section-card" id={id} aria-labelledby={`${id}-title`}>
    <header className="legal-section-card__header">
      <h2 id={`${id}-title`} className="legal-section-card__title">
        {title}
      </h2>
    </header>
    <div className="legal-section-card__body">{children}</div>
  </article>
);

export default LegalSectionCard;
